module.exports = __webpack_public_path__ + "images/emoji/toilet.6cebcd8fe05710743c4f.png";